export default __webpack_public_path__ + "static/media/9.9c2f1385.jpg";